// src/config/toastConfig.js

export const toastConfig = {
  position: "bottom-right",
  theme: "dark",
  className: "dark",
  toastOptions: {
    style: {
      background: '#1f2937', // gray-800
      border: '1px solid #374151', // gray-700
      color: '#fff',
    },
    success: {
      iconTheme: {
        primary: '#818cf8', // indigo-400
        secondary: '#1f2937', // gray-800
      },
    },
  }
}; 